import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {FieldValue} from '../../../form-renderer/interfaces/FieldValue';
import {StringUtilities} from '../../../utilities/StringUtilities';
import {EFieldType} from '../../../form-builder/enums/e-field-type.enum';
import {DateFieldService} from '../date-field/date-field.service';
import {IntegerFieldComponent} from '../../components/integer-field/integer-field.component';
import {DecimalFieldComponent} from '../../components/decimal-field/decimal-field.component';
import {DateFieldComponent} from '../../components/date-field/date-field.component';
import {TextFieldComponent} from '../../components/text-field/text-field.component';
import {CheckboxFieldComponent} from '../../components/checkbox-field/checkbox-field.component';
import {SelectFieldComponent} from '../../components/select-field/select-field.component';
import {TimestampFieldComponent} from '../../components/timestamp-field/timestamp-field.component';
import {YesNoFieldComponent} from '../../components/yes-no-field/yes-no-field.component';
import {CalculationFieldComponent} from '../../components/calculation-field/calculation-field.component';
import {FieldComponentAbstract} from '../../components/abstracts/FieldComponentAbstract';
import {Type} from '@angular/core/src/type';
import {DefaultReadonlyFieldComponent} from '../../components/default-readonly-field/default-readonly-field.component';

@Injectable()
export class FieldFormService {

  constructor(private dateService: DateFieldService) { }

  toFormGroup(fieldValues: FieldValue[]) {
    const group: any = {};
    for (const fieldValue of fieldValues) {
      if (fieldValue.field.readonly) continue;
      if (fieldValue.field.type === EFieldType.CALCULATION) continue;
      group[StringUtilities.camelize(fieldValue.field.name)] = this.getFormControl(fieldValue);
    }
    return new FormGroup(group);
  }

  public getFieldComponent(type: EFieldType): Type<FieldComponentAbstract> {
    switch (type) {
      case EFieldType.INTEGER: return IntegerFieldComponent;
      case EFieldType.DECIMAL: return DecimalFieldComponent;
      case EFieldType.DATE: return DateFieldComponent;
      case EFieldType.TEXT: return TextFieldComponent;
      case EFieldType.CHECKBOX: return CheckboxFieldComponent;
      case EFieldType.DROPDOWN: return SelectFieldComponent;
      case EFieldType.TIMESTAMP: return TimestampFieldComponent;
      case EFieldType.YES_NO: return YesNoFieldComponent;
      case EFieldType.CALCULATION: return CalculationFieldComponent;
    }
  }

  getReadonlyFieldComponent(type: EFieldType): Type<FieldComponentAbstract> {
    switch (type) {
      case EFieldType.CHECKBOX: return CheckboxFieldComponent;
      case EFieldType.YES_NO: return YesNoFieldComponent;
      default: return DefaultReadonlyFieldComponent;
    }
  }


  public getFormControl(fieldValue: FieldValue, required = fieldValue.field.required) {
    const validators = [];
    if (required)
      validators.push(Validators.required);
    switch (fieldValue.field.type) {
      case EFieldType.DATE:
        return new FormControl(this.dateService.parseServerDate(fieldValue.date_value), validators);
      case EFieldType.DROPDOWN:
        return new FormControl(fieldValue.select_value, validators);
      case EFieldType.TEXT:
        return new FormControl(fieldValue.string_value, validators);
      case EFieldType.DECIMAL:
        return new FormControl(fieldValue.decimal_value, validators);
      case EFieldType.CHECKBOX:
        return new FormControl(fieldValue.check_value, validators);
      case EFieldType.INTEGER:
        return new FormControl(fieldValue.int_value, validators);
      case EFieldType.TIMESTAMP:
        return new FormControl(fieldValue.timestamp_value, validators);
      case EFieldType.YES_NO:
        return new FormControl(fieldValue.yes_no_value, validators);
      default:
        return null;
    }
  }

  getFieldValueBySignature(signature: string, fieldValues: FieldValue[]) {
    const remaining = fieldValues.filter((fieldValue: FieldValue) => fieldValue.field.signature === signature);
    if (remaining.length === 0)
      return null;
    return remaining[0];
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/services/field-form/field-form.service.ts